var HighlightCarrousel = function() {

	var comp = $('[data-component="highlight-carrousel"]');

	this.init = function() {

		this.HighlightsSlider();

	}

	this.HighlightsSlider = function(){

		comp.find('.slider-holder').slick({
			arrows: false,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '400px',
			responsive: [
				{
					breakpoint: 2000,
					settings: {
						centerPadding: '300px'
					}
				},
				{
					breakpoint: 1650,
					settings: {
						centerPadding: '200px'
					}
				},
				{
					breakpoint: 1450,
					settings: {
						centerPadding: '150px'
					}
				},
				{
					breakpoint: 1370,
					settings: {
						centerPadding: '100px'
					}
				},
				{
					breakpoint: 1200,
					settings: {
						centerPadding: '75px'
					}
				},
				{
					breakpoint: 1050,
					settings: {
						centerPadding: '50px'
					}
				},
				{
					breakpoint: 992,
					settings: {
						centerPadding: '90px'
					}
				},
				{
					breakpoint: 870,
					settings: {
						centerPadding: '50px'
					}
				},
				{
					breakpoint: 768,
					settings: {
						centerPadding: '150px'
					}
				},
				{
					breakpoint: 670,
					settings: {
						centerPadding: '120px'
					}
				},
				{
					breakpoint: 610,
					settings: {
						centerPadding: '100px'
					}
				},
				{
					breakpoint: 550,
					settings: {
						centerPadding: '80px'
					}
				},
				{
					breakpoint: 500,
					settings: {
						centerPadding: '60px'
					}
				},
				{
					breakpoint: 470,
					settings: {
						centerPadding: '40px'
					}
				},
				{
					breakpoint: 415,
					settings: {
						centerPadding: '35px'
					}
				},
				{
					breakpoint: 390,
					settings: {
						centerPadding: '30px'
					}
				},
				{
					breakpoint: 370,
					settings: {
						centerPadding: '20px'
					}
				},
				{
					breakpoint: 350,
					settings: {
						centerPadding: '10px'
					}
				}
			]
		});

	}

	return this.init();

}
